import { useState } from "react";
import { SelectedArmyImage } from "./MainImageDialog";

export function useStagedImage(image: SelectedArmyImage | null) {
  const [stagedImage, setStagedImage] = useState(image);
  return { stagedImage, setStagedImage };
}
